<template>
  <div>
    <div class="tengxun_list">
      <div class="tengxun_box" @click="todetail(index)" v-for="(item,index) in tengxunList">
        <div class="tengxunbox_left">
          <img class="tengxun_img" :src="item.imgurl" />
          <div class="tengxun_des">{{item.name}}</div>
        </div>
        <img class="tengxun_to" src="/static/xiangyou.png" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tengxunList: [{
            name: "QQ会员充值",
            imgurl: "/static/qqVIP.png"
          },
          {
            name: "Q币充值",
            imgurl: "/static/Qbi.png"
          },
          {
            name: "英雄联盟点券充值",
            imgurl: "/static/yingxiong.png"
          },
          {
            name: "地下城与勇士点券充值",
            imgurl: "/static/dixiacheng.png"
          },
          {
            name: "穿越火线点券充值",
            imgurl: "/static/chuanyuehuoxian.png"
          },
          {
            name: "剑灵点券充值",
            imgurl: "/static/jianling.png"
          },
          {
            name: "逆战点券充值",
            imgurl: "/static/nizhan.png"
          },
          {
            name: "NBA2KOL点券充值",
            imgurl: "/static/NBA2KOL.png"
          }
        ]

      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      todetail(e) {
        this.$router.push({
          path: "/tengxunDetail",
          query: {
            tengxunDetailId: e
          }
        })
      }
    }
  }
</script>

<style>
  .tengxun_list {
    margin: 20px;
  }

  .tengxun_box {
    width: 95%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    /* background-image: url(../../../static/aiqiyibanner.png); */
  }

  .tengxunbox_left {
    display: flex;
    align-items: center;
  }

  .tengxun_img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    margin: 10px;
  }

  .tengxun_des {}

  .tengxun_to {
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/tengxun/tengxunList.vue